export const rentFieldConfiguration = [
  {
    name: "assetAffected",
    label: "Asset Affected",
    type: "select",
    options: [
      { label: "Truck", value: "Truck" },
      { label: "Trailer", value: "Trailer" },
    ],
    validation: { required: "Asset Affected is required" },
  },
  {
    name: "assetNumber",
    label: "Asset Number",
    type: "combo",
    dataKey: "assets",
    validation: { required: "Asset Number is required" },
  },
  {
    name: "authorityCompanyId",
    label: "Authority Company",
    type: "combo",
    dataKey: "authorityCompanies",
    validation: { required: "Authority Company is required" },
  },
  {
    name: "transactionType",
    label: "Transaction Type",
    type: "select",
    options: [
      { label: "Rent In Local", value: "RENT-IN-LOCAL" },
      { label: "Rent In OTR", value: "RENT-IN-OTR" },
      { label: "L2B", value: "L2B" },
      { label: "Lease Out", value: "LEASE-OUT" },
      { label: "Rent Out", value: "RENT-OUT" },
      { label: "Personal", value: "PERSONAL" },
      { label: "Available", value: "AVAILABLE" },
    ],
    validation: { required: "Transaction Type is required" },
  },
  {
    name: "billToId",
    label: "Bill To",
    type: "combo",
    dataKey: "billTos",
    validation: { required: "Bill To is required" },
  },
  {
    name: "soldToId",
    label: "Sold To",
    type: "combo",
    dataKey: "soldTos",
  },
  {
    name: "driverId",
    label: "Driver",
    type: "combo",
    dataKey: "drivers",
    validation: { required: "Driver is required" },
  },
  {
    name: "rentalTerm",
    label: "Rental Term",
    type: "number",
    validation: { required: "Rental term is required" },
  },
  {
    name: "billingFrequency",
    label: "Billing Frequency",
    type: "select",
    options: [
      { label: "Weekly", value: "Weekly" },
      { label: "Monthly", value: "Monthly" },
      { label: "Yearly", value: "Yearly" },
    ],
    validation: { required: "Billing frequency is required" },
  },
  {
    name: "baseRentalRate",
    label: "Base Rental Rate",
    type: "number",
    validation: { required: "Base rental rate is required" },
  },
  {
    name: "mileageRate",
    label: "Mileage Rate",
    type: "number",
  },
  {
    name: "leaseTerm",
    label: "Lease Term (Months)",
    type: "number",
    validation: { required: "Lease term is required" },
  },
  {
    name: "startDate",
    label: "Start Date",
    type: "date",
    validation: { required: "Start date is required" },
  },
  {
    name: "endDate",
    label: "End Date",
    type: "date",
  },
  {
    name: "downPayment",
    label: "Reimbursable deposit",
    type: "number",
  },
  {
    name: "mileageCaps",
    label: "Mileage Caps",
    type: "number",
    disabled: true,
  },
  {
    name: "startMileage",
    label: "Start Mileage",
    type: "number",
  },
  {
    name: "endMileage",
    label: "End Mileage",
    type: "number",
  },
  {
    name: "remainingBalance",
    label: "Remaining Balance",
    type: "number",
    validation: { required: "Remaining balance is required" },
  },
];

export const rentInitialValues = {
  assetAffected: "",
  assetNumber: "",
  authorityCompanyId: "",
  transactionType: "",
  billToId: "",
  soldToId: "",
  driverId: "",
  rentalTerm: "",
  billingFrequency: "",
  baseRentalRate: 0,
  mileageRate: 0,
  leaseTerm: 0,
  startDate: "",
  endDate: null as string | null,
  downPayment: 0,
  mileageCaps: 0,
  startMileage: 0,
  endMileage: 0,
  remainingBalance: 0,
};

export const makeFieldConfigDynamic = (
  fields: any[],
  setFieldState: (type: string) => void,
  assetAffected: string,
) => {
  return fields.map((field) => {
    if (field.name === "assetAffected") {
      return {
        ...field,
        onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
          setFieldState(event.target.value),
      };
    } else if (field.name === "assetNumber") {
      return {
        ...field,
        disabled: assetAffected === "",
      };
    }
    return field;
  });
};
